module.exports = __webpack_public_path__ + "img/aboutus.dd0b4bb8.png";